import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "button-body" }
const _hoisted_2 = {
  class: "body-left",
  key: "body-left"
}
const _hoisted_3 = {
  key: 1,
  class: "body-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["base-button", { disabled: _ctx.loading, shake: _ctx.shake, shine: _ctx.shine, grow: _ctx.grow, hover: _ctx.hover }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_Spinner, {
                key: "spinner",
                class: _normalizeClass(["spinner-wrap", { transition: !_ctx.loadingNoText }])
              }, null, 8, ["class"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (!_ctx.loadingNoText || !_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "left", {}, undefined, true)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.loadingNoText || !_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}